import { createVanIconComponent } from "./van"

const Column = createVanIconComponent("column")
export default Column
